"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetSyncConfig = exports.isVariableSyncConfig = exports.isMetricSyncConfig = exports.isCommissionSyncConfig = exports.SyncType = void 0;
var SyncType;
(function (SyncType) {
    SyncType["METRIC"] = "METRIC";
    SyncType["COMMISSION"] = "COMMISSION";
    SyncType["VARIABLE"] = "VARIABLE";
    SyncType["NET"] = "NET";
})(SyncType = exports.SyncType || (exports.SyncType = {}));
const isCommissionSyncConfig = (v) => v.type === SyncType.COMMISSION;
exports.isCommissionSyncConfig = isCommissionSyncConfig;
const isMetricSyncConfig = (v) => v.type === SyncType.METRIC;
exports.isMetricSyncConfig = isMetricSyncConfig;
const isVariableSyncConfig = (v) => v.type === SyncType.VARIABLE;
exports.isVariableSyncConfig = isVariableSyncConfig;
const isNetSyncConfig = (v) => v.type === SyncType.NET;
exports.isNetSyncConfig = isNetSyncConfig;
